"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import _ from "underscore";
import classNames from "classnames";
import { escapeRegExp } from "../../util/strings";
function cloneElement(e) {
  const clone = e.target.cloneNode();
  clone.removeAttribute("data-reactid");
  return clone;
}
function shouldHighlight(state, line) {
  if (!state.escapedTextToHighlight) {
    return false;
  }
  return line.chars.match(state.escapedTextToHighlight);
}
function textLine(props, state, line, index) {
  const className = classNames({
    "o-t": true,
    "o-h": shouldHighlight(state, line)
  });
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: styleForLine(props, line),
      "data-chars": line.chars,
      "data-top": line.top,
      "data-left": line.left,
      "data-width": line.width,
      "data-height": line.height,
      key: "text_line_" + index,
      className
    },
    "\xA0"
  );
}
function styleForLine(props, line) {
  return {
    top: line.top * (props.imageHeight || 0),
    left: line.left * (props.imageWidth || 0),
    width: line.width * (props.imageWidth || 0) + 2,
    height: line.height * (props.imageHeight || 0) + 2
  };
}
class PageTextHighlighter extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      escapedTextToHighlight: escapeRegExp(this.props.textToHighlight)
    });
    __publicField(this, "enableDragAndDrop", () => {
      $(this.container()).find(".o-t").draggable({
        cursor: "move",
        revert: "invalid",
        scope: "dnd-text",
        zIndex: 100,
        appendTo: "body",
        helper: cloneElement
      });
    });
    __publicField(this, "disableDragAndDrop", () => {
      $(this.container()).find(".ui-draggable").draggable("destroy");
    });
    __publicField(this, "container", () => {
      return ReactDOM.findDOMNode(this.refs.container);
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      escapedTextToHighlight: escapeRegExp(nextProps.textToHighlight)
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.lines !== prevProps.lines) {
      this.enableDragAndDrop();
    }
  }
  componentDidMount() {
    this.enableDragAndDrop();
  }
  componentWillUnmount() {
    this.disableDragAndDrop();
  }
  render() {
    const classes = classNames({
      "ocred-document__wrapper": true,
      "ocred-document__wrapper--enabled": true
    });
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "PageTextHighlighter",
        className: classes,
        ref: "container"
      },
      _.map(
        this.props.lines,
        (line, index) => textLine(this.props, this.state, line, index)
      )
    );
  }
}
export default PageTextHighlighter;
